import React, { useContext } from "react";
import { Button, Modal } from "Shared/ui";
import { UpdateIbanAccount } from "./update_iban_account";
import { useSelector } from "react-redux";
import { selectWithdraw } from "Shared/store/withdraw";
import { WithdrawModalsContext } from "../context/WithdrawModalContext";
import "../withdraw_modals.scss";

export const UpdateSelectedAccount = () => {
	const { onOk, onCancelUpdate, errors, isUpdate } = useContext(WithdrawModalsContext);
	const isVisible = useSelector(selectWithdraw.isVisibleUpdateAcc);

	const buttons = [
		<Button
			type="bordered-azure"
			key={"cancel"}
			text="Cancel"
			onClick={onCancelUpdate}
			className="withdraw-modal__button mr-10"
		/>,
		<Button
			type="azure"
			key={"ok"}
			text={isUpdate ? "Save" : "Add"}
			onClick={onOk}
			disabled={JSON.stringify(errors) !== "{}"}
		/>,
	];

	return (
		<Modal isVisible={isVisible} buttons={buttons} title={"Please, enter your data"}>
			<div className="withdraw-modal">
				<UpdateIbanAccount />
			</div>
		</Modal>
	);
};
